<app-add-form
  data-testid="outbound-delivery-order-add-form"
  #addForm
  [title]="'outbound_management.pages.add_outbound_order' | translate"
  [formFields]="updatedFormFields()"
  [tableSections]="tableSections()"
  [headerActions]="headerActions()"
  [loading]="loading()"
  (formAction)="onFormAction($event.action)"
  (tableAction)="onTableAction($event)"
  (formValueChanges)="onFormValueChanges($event)"
></app-add-form>

<!-- Transfer Order Selection Dialog -->
<p-dialog
  data-testid="outbound-delivery-order-add-transfer-order-dialog"
  [visible]="showTransferOrderDialog()"
  [header]="
    'outbound_management.dialog.select_transfer_order.title' | translate
  "
  [modal]="true"
  [style]="{ width: '80vw', maxWidth: '1200px' }"
  [draggable]="false"
  [resizable]="false"
  (visibleChange)="showTransferOrderDialog.set($event)"
  (onHide)="onTransferOrderDialogCancel()"
>
  <div class="p-4">
    <app-data-table
      data-testid="outbound-delivery-order-add-transfer-order-table"
      [columns]="transferOrderColumns()"
      [dataSource]="transferOrderList()"
      [loading]="false"
      [hasCheckColumn]="false"
      [totalRecords]="transferOrderList().length"
      [first]="0"
      [rows]="20"
    >
      <ng-template
        #customTemplate
        let-value
        let-rowData="rowData"
        let-column="column"
      >
        @if (column.prop === "status") {
          <span class="status-badge status-{{ rowData.status }}">
            {{
              rowData.status === "APPROVED"
                ? ("logic_transfer.status.approved" | translate)
                : rowData.status
            }}
          </span>
        }
      </ng-template>
      <ng-template #actionsTemplate let-rowData>
        <p-button
          [attr.data-testid]="'outbound-delivery-order-add-action-select-' + rowData.id"
          [label]="'common.actions.select' | translate"
          (onClick)="onTransferOrderSelect(rowData)"
          [outlined]="true"
          size="small"
        ></p-button>
      </ng-template>
    </app-data-table>
  </div>
  <ng-template pTemplate="footer">
    <p-button
      data-testid="outbound-delivery-order-add-cancel-transfer-order-dialog-btn"
      [label]="'common.actions.cancel' | translate"
      (onClick)="onTransferOrderDialogCancel()"
      [outlined]="true"
    ></p-button>
  </ng-template>
</p-dialog>

<p-toast data-testid="outbound-delivery-order-add-toast"></p-toast>
